import { AfterViewInit, Directive, ElementRef, NgZone } from '@angular/core';
import SimpleBar from 'simplebar';

@Directive({
  selector: '[mdSimpleBar]',
})
export class SimplebarDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef, private ngZone: NgZone) {}

  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const scrollBar = new SimpleBar(this.elementRef.nativeElement);
      });
    });
  }
}
